import React from 'react';
import { Button } from './ui/Button';
import { Shield, Clock, Check } from 'lucide-react';
export function Pricing() {
  return <section id="pricing" className="py-16 md:py-24 px-4 bg-[#F6EEDC]" data-id="element-165">
      <div className="max-w-5xl mx-auto" data-id="element-166">
        {/* Product Image - Now above the pricing section */}
        <div className="mb-12 max-w-2xl mx-auto" data-id="element-167">
          <div className="rounded-2xl overflow-hidden shadow-xl border border-[#2E2E2E]/5" data-id="element-168">
            <img src="https://cdn.magicpatterns.com/uploads/v75ce9ekmFxzsPd1BEFCko/PRINCIPAL_Y_BONUS.png" alt="30 Cenas Anti-Pelea - Ebook completo con bonos" className="w-full h-auto" data-id="element-169" />
          </div>
        </div>

        {/* Pricing Card - Now centered */}
        <div className="max-w-md mx-auto" data-id="element-170">
          <div className="bg-[#FDFBF9] rounded-2xl shadow-xl overflow-hidden border border-[#2E2E2E]/5" data-id="element-171">
            <div className="bg-[#0D3B66] p-6 text-center" data-id="element-172">
              <h2 className="text-2xl md:text-3xl font-bold text-white" data-id="element-173">
                30 Cenas Anti-Pelea
              </h2>
              <p className="text-white/80 mt-2" data-id="element-174">+ 3 bonos incluidos</p>
            </div>

            <div className="p-8 md:p-10" data-id="element-175">
              <div className="text-center mb-8" data-id="element-176">
                {/* Original price crossed out */}
                <div className="mb-2" data-id="element-177">
                  <span className="text-lg text-[#2E2E2E]/40 line-through" data-id="element-178">
                    ARS $24.999
                  </span>
                  <span className="ml-2 bg-[#E0435A] text-white text-xs font-bold px-2 py-1 rounded-full" data-id="element-179">
                    -48% OFF
                  </span>
                </div>

                {/* Current price */}
                <div className="flex items-center justify-center" data-id="element-180">
                  <span className="text-xl text-[#2E2E2E]/50 mr-2" data-id="element-181">ARS</span>
                  <span className="text-5xl md:text-6xl font-bold text-[#E0435A]" data-id="element-182">
                    $12.999
                  </span>
                </div>
                <p className="text-[#2E2E2E]/60 mt-3" data-id="element-183">
                  Compra única · Acceso inmediato
                </p>
              </div>

              {/* CTA Button - Green style like reference */}
              <a href="https://vitaliaguides.com/cart/add?id=47286550823075&quantity=1" className="w-full bg-[#8B9F3A] hover:bg-[#7A8C33] text-white font-bold text-lg py-4 px-6 rounded-full shadow-lg transition-all duration-200 flex items-center justify-center gap-2 mb-4" data-id="element-184">
                ¡Sí, quiero 30 Cenas Anti‑Pelea!
                <span className="text-xl" data-id="element-185">→</span>
              </a>

              {/* Security text below button */}
              <p className="text-center text-sm text-[#8B9F3A] mb-6" data-id="element-186">
                <Check className="w-4 h-4 inline mr-1" data-id="element-187" />
                Pago seguro ·
                <Check className="w-4 h-4 inline mx-1" data-id="element-188" />
                Acceso inmediato
              </p>

              {/* Payment security badge */}
              <div className="mb-8" data-id="element-189">
                <img src="https://cdn.magicpatterns.com/uploads/rT8tiiYJh9W5UNe6yBJnrw/image.png" alt="Pago seguro garantizado - Visa, Mastercard, Maestro, Mercado Pago" className="w-full max-w-[280px] mx-auto h-auto" data-id="element-190" />
              </div>

              {/* Guarantee and Access icons */}
              <div className="flex justify-center gap-8 pt-6 border-t border-[#2E2E2E]/10" data-id="element-191">
                <div className="flex flex-col items-center text-center" data-id="element-192">
                  <div className="w-12 h-12 rounded-full bg-[#E0435A]/10 flex items-center justify-center mb-2" data-id="element-193">
                    <Shield className="w-6 h-6 text-[#E0435A]" data-id="element-194" />
                  </div>
                  <span className="text-sm text-[#2E2E2E]/70 font-medium" data-id="element-195">
                    Garantía de 7 días
                  </span>
                </div>
                <div className="flex flex-col items-center text-center" data-id="element-196">
                  <div className="w-12 h-12 rounded-full bg-[#E0435A]/10 flex items-center justify-center mb-2" data-id="element-197">
                    <Clock className="w-6 h-6 text-[#E0435A]" data-id="element-198" />
                  </div>
                  <span className="text-sm text-[#2E2E2E]/70 font-medium" data-id="element-199">
                    Acceso inmediato
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}